// import i18next from '../../lang';

export const menuPath = {
	"dashboard": {
		"id": "dashboard",
		"text": "대시보드", // i18next.t("대시보드"),
		"isClick": true
	},
	"projects": {
		"id": "projects",
		"text": "평가 과제 관리", // i18next.t("평가 과제 관리"),
		"isClick": true
	},
	"assignments": {
		"id": "assignments",
		"text": "평가 과제 운영", // i18next.t("평가 과제 운영"),
		"isClick": true
	},
	"students": {
		"id": "students",
		"text": "학생 관리", // i18next.t("학생 관리"),
		"isClick": true
	},
	"code": {
		"id": "code",
		"text": "상세", // i18next.t("{{category}} 상세", { category: "{{category}}" }),
		"isClick": true
	},
	"projectCode": {
		"id": "{{projectCode}}",
		"text": "{{projectCode}}",
		"isClick": false
	},
	"submissionCode": {
		"id": "{{submissionCode}}",
		"text": "{{submissionCode}}",
		"isClick": false
	},
	"info": {
		"id": "info",
		"text": "과제 개요", // i18next.t("과제 개요"),
		"isClick": true
	},
	"exam": {
		"id": "exam",
		"text": "문항 생성", // i18next.t("문항 생성"),
		"isClick": true
	},
	"rag": {
		"id": "rag",
		"text": "RAG", // i18next.t("RAG"),
		"isClick": true
	},
	"answer": {
		"id": "answer",
		"text": "교사 답안", // i18next.t("교사 답안"),
		"isClick": true
	},
	"rubric": {
		"id": "rubric",
		"text": "평가 기준표", // i18next.t("평가 기준표"),
		"isClick": true
	},
	"review": {
		"id": "review",
		"text": "검토", // i18next.t("검토"),
		"isClick": true
	},
	"assignment-info": {
		"id": "assignment-info",
		"text": "과제 정보", // i18next.t("과제 정보"),
		"isClick": true
	},
	"submissions": {
		"id": "submissions",
		"text": "제출물 관리", // i18next.t("제출물 관리"),
		"isClick": true
	},
	"scoring": {
		"id": "scoring",
		"text": "채점 및 피드백", // i18next.t("채점 및 피드백"),
		"isClick": true
	},
	"results": {
		"id": "results",
		"text": "결과 내보내기", // i18next.t("결과 내보내기"),
		"isClick": true
	},
	"assign-info": {
		"id": "assign-info",
		"text": "과제 정보", // i18next.t("과제 정보"),
		"isClick": true
	},
	"assign-students": {
		"id": "assign-students",
		"text": "배정 대상", // i18next.t("배정 대상"),
		"isClick": true
	},
	"select-project": {
		"id": "select-project",
		"text": "과제 선택", // i18next.t("과제 선택"),
		"isClick": true
	},
	"confirm-assign": {
		"id": "confirm-assign",
		"text": "확인 및 배정", // i18next.t("확인 및 배정"),
		"isClick": true
	},
	"print-worksheets": {
		"id": "print-worksheets",
		"text": "학습지 출력", // i18next.t("학습지 출력"),
		"isClick": true
	},
	"my-assignments": {
		"id": "my-assignments",
		"text": "내 과제", // i18next.t("내 과제"),
		"isClick": true
	},
	"online-assignment": {
		"id": "online-assignment",
		"text": "온라인 과제", // i18next.t("온라인 과제"),
		"isClick": true
	},
	"result-view": {
		"id": "result-view",
		"text": "결과 보기", // i18next.t("결과 보기"),
		"isClick": true
	}
};
